exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-modal-language-switcher .sf-modal__container{width:auto}.m-modal-language-switcher .sf-footer__container{margin:var(--spacer-xl) calc(var(--spacer-lg) * -1);padding:0}.m-modal-language-switcher .sf-footer-column{padding:0 var(--spacer-lg)}\n", ""]);

// exports
